export default {"src":"/_next/static/media/lines.976dddfe.svg","height":313,"width":149};